var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonScan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8795 12.8598L17.6747 10.6949C17.8757 10.5802 18 10.3669 18 10.1376V5.80814C18 5.57925 17.8752 5.36551 17.6747 5.2508L13.8795 3.08583C13.6785 2.97111 13.4293 2.97166 13.2283 3.08583L9.43309 5.2508C9.23208 5.36551 9.10777 5.57925 9.10777 5.80814V13.5454L6.4464 15.0632L3.78502 13.5454V10.5093L6.4464 8.99143L8.20189 9.99248V7.95583L6.77174 7.14034C6.67315 7.08408 6.56032 7.05431 6.44585 7.05431C6.33138 7.05431 6.21854 7.08408 6.12051 7.14034L2.32535 9.30532C2.12433 9.41999 2 9.63326 2 9.8627V14.1921C2 14.4209 2.12488 14.6347 2.32535 14.7494L6.12051 16.9143C6.32097 17.0286 6.57073 17.0286 6.77174 16.9143L10.5669 14.7499C10.7679 14.6352 10.8923 14.4215 10.8923 14.1926V6.4553L10.9405 6.42825L13.5536 4.9375L16.215 6.4553V9.49143L13.5536 11.0093L11.8009 10.0093V12.046L13.2283 12.8603C13.4293 12.9746 13.6785 12.9746 13.8795 12.8603V12.8598Z",
    fill: "url(#paint0_linear_5512_28798)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5512_28798",
    x1: 10,
    y1: 3,
    x2: 10,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9034D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C40E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonScan);
export default __webpack_public_path__ + "static/media/polygon-scan.f5e012cc040975eb3b453b1811d4daf7.svg";
export { ForwardRef as ReactComponent };